<template>
  <columns>
    <column size="4">
      <router-link to="/"><logo type="night"/></router-link>
    </column>
    <column size="4">
      <router-link class="router-link" to="/about" @click.native="resetBodyClass">О компании</router-link>
      <!--<router-link class="router-link" to="/news" @click.native="resetBodyClass">Новости</router-link>-->
      <router-link class="router-link" to="/vacancies" @click.native="resetBodyClass">Вакансии</router-link>
      <router-link class="router-link" to="/legal" @click.native="resetBodyClass">Раскрытие<br/>информации</router-link>
      <router-link class="router-link" to="/contacts" @click.native="resetBodyClass">Контакты</router-link>
      <router-link class="router-link" to="/profile" @click.native="resetBodyClass">Личный кабинет</router-link>
    </column>
    <column size="4">
      <router-link class="router-link" to="/power" @click.native="resetBodyClass">Энергосбережение</router-link>
      <router-link class="router-link" to="/accounting" @click.native="resetBodyClass">Системы учёта</router-link>
      <router-link class="router-link" to="/audit" @click.native="resetBodyClass">Энергоаудит</router-link>
      <!--<router-link class="router-link" to="/regions" @click.native="resetBodyClass">Сетевой комплекс</router-link>-->
      <router-link class="router-link" to="/consulting" @click.native="resetBodyClass">Консалтинг</router-link>
      <router-link class="router-link" to="/trading" @click.native="resetBodyClass">Энерготрейдинг</router-link>
    </column>
  </columns>
</template>

<script>
import Logo from '@/components/Logo';
import Columns from '@/components/columns/Columns';
import Column from '@/components/columns/Column';

export default {
  components: {
    Logo,
    Columns,
    Column,
  },
  methods: {
    resetBodyClass () {
      document.body.setAttribute('class', '');
    }
  }
}
</script>



// WEBPACK FOOTER //
// HeaderBar.vue?09d53853